export default __webpack_public_path__ + "static/enjoy-your-loved-ones-2e5b85389c1ac937c28b7c23855ea87f.jpg";